module.exports = __webpack_public_path__ + "static/laboheme6-8f305572d5020d73f0802dfbd019ccc5.jpg";